// Labels shared by the Reminder Setup tabs. Values mirror the REM_* enums in the backend's prisma/schema.prisma.

// Only Super Admins may change the reminder setup (or read raw rows); Admins can browse it.
export const MANAGE_ROLE = "SUPER_ADMIN";

export const SOURCE_STATUS = {
  DRAFT: { label: "Draft", classes: "bg-surface_alt text-text_secondary border-border" },
  ACTIVE: { label: "Active", classes: "bg-success_bg text-success border-success_border" },
  PAUSED: { label: "Paused", classes: "bg-warning_bg text-warning border-warning_border" },
  ARCHIVED: { label: "Archived", classes: "bg-surface_alt text-text_muted border-border" },
};

export const SUBJECT_TYPE_LABEL = {
  USER: "User",
  NONE: "Platform",
};

export const DATA_TYPE_LABEL = {
  INT: "Number",
  NUMERIC: "Decimal",
  TEXT: "Text",
  DATE: "Date",
  TIMESTAMP: "Date & time",
  BOOLEAN: "Yes / No",
  INT_ARRAY: "Number list",
  TEXT_ARRAY: "Text list",
};

export const FIELD_ROLE_LABEL = {
  SUBJECT: "Subject",
  REFERENCE: "Reference",
  USER_REF: "User ref",
  EMAIL_REF: "Email ref",
  PROJECT_REF: "Project ref",
  ATTRIBUTE: "Attribute",
};

export const TRIGGER_TYPE_LABEL = {
  DATE_ANCHOR: "Date anchor",
  CONDITION: "Condition",
  DOMAIN_EVENT: "Domain event",
  BROADCAST: "Broadcast",
};

// Why a test run / run left a case out (the rule's applyAudience / applyCalendar).
export const FILTERED_OUT_LABEL = { not_in_audience: "Not in the audience", excluded: "Excluded", inactive: "Inactive user", not_working_day: "Not a working day" };

export const toOptions = (labels) => Object.entries(labels).map(([value, label]) => ({ value, label }));
